import React from 'react';
import { useTranslation } from 'react-i18next';
import { Placeholder, Section } from '@/components/ui';

const SHOTS = ['record', 'route', 'drive'] as const;

export const Screenshots: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Section
            id="screenshots"
            tint
            eyebrow={t('web.screenshots.eyebrow')}
            title={t('web.screenshots.title')}
            sub={t('web.screenshots.sub')}
        >
            <div className="grid grid--3">
                {SHOTS.map((shot) => (
                    <Placeholder
                        key={shot}
                        shape="phone"
                        label={t(`web.screenshots.${shot}`)}
                        hint={t('web.placeholder.hint')}
                    />
                ))}
            </div>
        </Section>
    );
};
